import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP8NrNew202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p8_nr_new_202606",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 40225,
  clicks: 784,
  adsSpendDollars: 4125,
  budgetDollars: 6000,
  salesDollars: 19669,
  bestEstimateRoas: 4.77,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.69,
  newCustomersAcquired: 45,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
